import type { ReactNode } from 'react';
import { contentWidth, sectionPad, tones, type SectionPad, type Tone } from '../../ui/sections';
type Props = {
  /** De toon van het vlak; de tekstkleur hoort erbij (klei en salie: shell). */
  tone: Tone;
  children: ReactNode;
  /** Id van de kop in deze sectie (voorkeur), of anders een naam voor schermlezers. */
  labelledBy?: string;
  label?: string;
  id?: string;
  pad?: SectionPad;
  /** Extra klassen op de binnenkant (raster, gaten); de breedte en zijmarge staan al vast. */
  className?: string;
  /** `false`: geen inhoudsbreedte (beeld tot de rand); de sectie geeft dan alleen toon en ruimte. */
  contained?: boolean;
};

/**
 * De sectiebouwsteen van de publieke site: één toon, vaste verticale ruimte en de inhoudsbreedte.
 * Een pagina is een rij van deze vlakken (docs/VORMGEVING.md › Bouwstenen).
 */
export function Section({
  tone,
  children,
  labelledBy,
  label,
  id,
  pad = 'default',
  className = '',
  contained = true
}: Props) {
  return <section id={id} className={`${tones[tone]} ${sectionPad[pad]}`} aria-labelledby={labelledBy} aria-label={labelledBy ? undefined : label} data-id="element-8801" data-mp="19hw661celtrw">
      {contained ? <div className={`${contentWidth} ${className}`} data-id="element-8802" data-mp="2jyi9p1wm5xyr">{children}</div> : children}
    </section>;
}